module.exports = __webpack_public_path__ + "static/img/share_consult_info_t.6d8a1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_consult_info_t.png
// module id = /6bq
// module chunks = 1